import Vue from 'vue'
import Router from 'vue-router'
import store from '@app/store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '',
      component: () => import('@app/layouts/web/Web.vue'),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('./views/pages/Home.vue'),
          meta: {
            alwaysSticky: false,
          }
        },
      ]
    },

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ],
})

router.afterEach((to, from) => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }

  if (to.meta.alwaysSticky) {
    store.dispatch('setMenuSticky', true);
  }
  else {
    store.dispatch('setMenuSticky', false);
  }


})

export default router
